import api from "@api/index";
import { components, operations } from "@api/schema";
import { IAppCurrency } from "@App/types";
import { PaymentMethodType } from "../types";
import { IPaymentMethodProvider } from "./paymentMethods";

export const API_PATH = "payments";

export type IPaymentOrigin<T extends PaymentMethodType> =
  T extends PaymentMethodType.CREDIT_CARD
    ? IPaymentMethodProvider<T> extends "stripe"
      ? "stripe"
      : PaymentMethodType.CREDIT_CARD
    : T extends PaymentMethodType.BANK_TRANSFER
    ? PaymentMethodType.BANK_TRANSFER
    : T extends PaymentMethodType.BANCONTACT
    ? IPaymentMethodProvider<T> extends "stripe"
      ? "stripe_bancontact"
      : "other"
    : "other";

type PaymentConfig<T extends PaymentMethodType> = {
  paymentMethod: T;
  provider: IPaymentMethodProvider<T>;
  config: IPaymentMethodProvider<T> extends "stripe"
    ? {
        clientSecret: string;
        paymentIntentId: string;
        amountCents: number;
        currency: IAppCurrency;
      }
    : IPaymentMethodProvider<T> extends "company_operations"
    ? {
        iban: string;
        currency: IAppCurrency;
        amountCents: number;
        statementDescriptor: string;
        description: string;
      }
    : Record<string, unknown>;
};

export type SetupPaymentProps<T extends PaymentMethodType> = {
  resourceId: components["schemas"]["basket"]["id"];
  resourceType: components["schemas"]["payableResource"]["resourceType"];
  paymentMethod: T;
  paymentProvider: IPaymentMethodProvider<T>;
  relatedServiceId?: number;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const setupPayment = async <T extends PaymentMethodType>(
  body: SetupPaymentProps<T>
) => {
  const {
    data: { config },
  } = await api.post<SetupPaymentProps<T>, PaymentConfig<T>>(
    `${API_PATH}/setup`,
    body
  );
  return config;
};

export type ProcessPaymentProps =
  operations["processPayment"]["requestBody"]["content"]["application/json"];

export const processPayment = async (body: ProcessPaymentProps) => {
  const { data } = await api.post<ProcessPaymentProps, object>(
    "process_payment",
    body
  );
  return data;
};
